module.exports = __webpack_public_path__ + "static/img/tool-box.01144b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/v3/img/tool-box.png
// module id = dP/B
// module chunks = 10